const FILE_PROCESSING_TIMEOUT_MS = 30000;

let pendingCount = 0;
const waiters = [];

const resolveAllWaiters = () => {
  waiters.splice(0).forEach((resolve) => resolve());
};

const forceResetPendingState = (message) => {
  if (pendingCount === 0 && waiters.length === 0) {
    return;
  }
  console.warn(`[fileProcessing] ${message}`, { pendingCount });
  pendingCount = 0;
  resolveAllWaiters();
};

export const registerFileProcessing = () => {
  pendingCount += 1;
};

export const completeFileProcessing = () => {
  if (pendingCount <= 0) return;
  pendingCount -= 1;
  if (pendingCount === 0) {
    resolveAllWaiters();
  }
};

export const waitForFileProcessing = (
  timeoutMs = FILE_PROCESSING_TIMEOUT_MS,
) => {
  if (pendingCount === 0) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    let settled = false;

    const done = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      resolve();
    };

    waiters.push(done);

    const timeoutId = setTimeout(() => {
      if (settled) return;
      forceResetPendingState(
        `Timed out after ${timeoutMs}ms waiting for file processing`,
      );
    }, timeoutMs);
  });
};

export { FILE_PROCESSING_TIMEOUT_MS };
